/*
Create By KRISANA : 2023-11-03

    Edit By POOM : 2024-01-26  เวลา return API    มีการใช้  status_ID === 0  ซึ่งผิด  แก้ให้ถูก คือ status_ID === 1
    Edit By POOM : 2024-05-10  เวลา return API ให้เช็คว่าถ้า status_ID === 2  ให้เด้ง SessionTimeOut ทันที

*/
//import React from "react";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import Pathurl from "../Class/Pathurl.json";

import {
  Class_ETC_MsgError,
  Class_ETC_MsgSuccess,
  Class_ETC_Warning,
  Class_ETC_MsgErrorfocusByID,
  Class_ETC_SessionTimeOut
} from "../Class/Class_Etc";

import MsgDescription from "../Class/MsgDescription.json";
import ConfigETC from "../Class/ConfigETC.json";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";

import BootstrapSwitchButton from 'bootstrap-switch-button-react'
// eslint-disable-next-line
import { DatePickerComponent, Inject, MaskedDateTime } from '@syncfusion/ej2-react-calendars';
import axios from "axios";
import PaginationActions from "../PartialView/PaginationActions";

function M_announcement() {
  //#region __ Parameter __

  const [isLoadProgress, setIsLoadProgress] = useState(true);
  const [isLoadedConfigData, setIsLoadedConfigData] = useState(false);
  const [configData, setConfigData] = useState([]);
  const [page, setPage] = useState(0);
  const [listAnnouncement, setListAnnouncement] = useState([]);
  // eslint-disable-next-line
  const [rowsPerPage, setRowsPerPage] = useState(ConfigETC.rowsPerPage); 
  const [isCount, setIsCount] = useState(0);
  const [isAnnounceStatus, setIsAnnounceStatus] = useState(true);
  const [pgAct, setPgAct] = useState("");
  
  //#endregion

  useEffect(() => {
    let supportsystem = localStorage.getItem("supportsystem");
    if (supportsystem === "allowcom0") {
      GetConfig();
      if (isLoadedConfigData === true) {
        BindList_Announcement("GET" ,function() {
          setIsLoadProgress(false);
        });
      }
    }
    else {
      window.location.replace("../" + Pathurl.no_permission);
    }
    // eslint-disable-next-line
  }, [isLoadedConfigData]);

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  const handleKeyDown = (event) => {
    if (event.key === 'Escape') {
      document.getElementById("modal-Add-Edit-Announcement").click();
    }
  };

  //#region __ Bind Data __
  async function GetConfig() {
    await fetch("../ConfigData.json")
      .then((res) => res.json())
      .then((data) => {
        setConfigData(data);
        setIsLoadedConfigData(true);
      })
      .catch((err) => err);
  }

  
  //#endregion


  //#region __ Onclick __

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
  };
  
  

function Onclick_Add_Edit_Announcement(Act, announce_id, announce_header, announce_text, announce_start_date, announce_end_date, announce_status) {
  setPgAct(Act);
  if (Act === "Add"){
    Clearvalueinmodel();
  }
  else {
    document.getElementById("hd_announce_id").value = announce_id;
    document.getElementById("txt_announce_header").value = announce_header;
    document.getElementById("txt_announce_text").value = announce_text;
    document.getElementById("txt_announce_start_date").value = announce_start_date;
    document.getElementById("txt_announce_end_date").value = announce_end_date;
    setIsAnnounceStatus(announce_status === 1 ? true : false);
  }
}

function onclick_DelAnnouncement(announce_id) {
  document.getElementById("hd_iddel").value = announce_id;
  Class_ETC_Warning(MsgDescription.CFM002, DelAnnouncement);
}
//#region #####################  POPUP SAVE Announcement          ###################

function Onclick_SaveAnnouncement() {
  setIsLoadProgress(true);
  var isError = "";
  let txtError = "";

  if (document.getElementById("txt_announce_header").value.trim() === "") 
  {
    txtError = "txt_announce_header";
  }

  else if (document.getElementById("txt_announce_text").value.trim() === "") 
  {
    txtError = "txt_announce_text";
  }
  else if (document.getElementById("txt_announce_start_date").value.trim() === "") 
  {
    txtError = "txt_announce_start_date";
  }
  else if (document.getElementById("txt_announce_end_date").value.trim() === "") 
  {
    txtError = "txt_announce_end_date";
  }

  if (txtError !== "") {
    isError = "Empty";
  }

  if (isError !== "") 
  {
        setIsLoadProgress(false);
        Class_ETC_MsgErrorfocusByID( MsgDescription.ERR001, txtError);
  }
  else {
    SaveAnnouncement();
  }
}
//#endregion #####################  POPUP SAVE Announcement          ###################

//#endregion __ Onclick __


  //#region __ Function __

  async function BindList_Announcement(isAct , _callback) {
    
    let token = localStorage.getItem("TStoken");
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);
    myHeaders.append("Content-Type", "application/json");
    
    var raw = "";
    
    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };

    await fetch(configData.API_URL + "Announce_GetList", requestOptions)
      .then((response) => response.json())
      .then((result) => {

        if (result.status_ID === 2) 
        {
          Class_ETC_SessionTimeOut();
        }
        else
        {

          if (result.total_Data > 0) {
            if (isAct === "DEL") {
              if (rowsPerPage * (page + 1) > result.total_Data) {
                let pagenow = Math.ceil(result.total_Data / rowsPerPage);
                setPage((pagenow === 0 ? 0 : pagenow - 1));
              }
            }
            else if (isAct === "GET") {
              setPage(0);
            }
            setListAnnouncement(result.data);
            setIsCount(result.total_Data);
            if (_callback != null) {
              _callback();
            }
          } else {
            setListAnnouncement([]);
            setIsCount(0);
            if (_callback != null) {
              _callback();
            }
          }

        }
      })
      .catch((error) => {
        setListAnnouncement([]);
        if (_callback != null) {
          _callback();
      }
      });
  }
  async function SaveAnnouncement() {
    var hd_announce_id = document.getElementById("hd_announce_id").value.trim();
    var txt_announce_header = document.getElementById("txt_announce_header").value.trim();
    var txt_announce_text = document.getElementById("txt_announce_text").value.trim();
    var txt_announce_start_date = document.getElementById("txt_announce_start_date").value.trim();
    var txt_announce_end_date = document.getElementById("txt_announce_end_date").value.trim();
    
    const formData = new FormData();
  
    formData.append("announce_id",hd_announce_id === -1 ? -1 : hd_announce_id);
    formData.append("announce_header",txt_announce_header === "" ? "" : txt_announce_header);
    formData.append("announce_text",txt_announce_text === "" ? "" : txt_announce_text);
    formData.append("announce_start_date",txt_announce_start_date === "" ? "" : txt_announce_start_date);
    formData.append("announce_end_date", txt_announce_end_date === "" ? "" : txt_announce_end_date);
    formData.append("announce_status", isAnnounceStatus === true ? "1" : "0");

    let token = localStorage.getItem("TStoken");

    let config = 
    {
      method: "post",
      maxBodyLength: Infinity,
      url: configData.API_URL + (pgAct === "Add" ? "Announce_Add" :"Announce_Edit"),
      headers: {
        // 'Content-Type': 'application/json',
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      data: formData,
      contentType: false, // Not to set any content header
      processData: false, // Not to process data
      async: false,
      traditional: true,
    };

    axios.request(config)
      .then((result) => {

        if (result.data.status_ID === 1) 
        {
          BindList_Announcement(false,function(){
            setIsLoadProgress(false);
            Class_ETC_MsgSuccess(MsgDescription.CFM001,null);
            document.getElementById("close_Announce_Add_Edit").click();
          });
        }
        else if  (result.data.status_ID === 2) 
        {
          Class_ETC_SessionTimeOut();
        }
        else 
        {
          setIsLoadProgress(false);
          Class_ETC_MsgError(result.data.status_Desc, null);
        }
      })
      .catch((error) => {
        setIsLoadProgress(false);
        Class_ETC_MsgError(MsgDescription.ERR002, null);
      });

}

async function DelAnnouncement() {
  setIsLoadProgress(true);
  try {
    let token = localStorage.getItem("TStoken");
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);
    myHeaders.append("Content-Type", "application/json");
    var raw = JSON.stringify({
      announce_id: document.getElementById("hd_iddel").value.trim(),
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    const response = await fetch(
      configData.API_URL + "Announce_Del",
      requestOptions
    );
    const json = await response.json();

    if (json.status_ID === 1) {
      BindList_Announcement(false,function(){
        setIsLoadProgress(false);
        document.getElementById("close_Announce_Add_Edit").click();
        Class_ETC_MsgSuccess(MsgDescription.CFM003, null);
      });
    
    }
    else if  (json.status_ID === 2) 
    {
      Class_ETC_SessionTimeOut();
    }
    else {
      setIsLoadProgress(false);
      Class_ETC_MsgError(json.status_Desc, null);
    }
  } catch {
    setIsLoadProgress(false);
    Class_ETC_MsgError(MsgDescription.ERR003, null);
    
  }
}

async function Clearvalueinmodel(){
  document.getElementById("txt_announce_header").value = "";
  document.getElementById("txt_announce_text").value = "";
  document.getElementById("txt_announce_start_date").value = "";
  document.getElementById("txt_announce_end_date").value = "";
  setIsAnnounceStatus(true);
}
  //#endregion

//#endregion
  return (
    <>
{isLoadProgress && (
        <div id="divLoadingProgress" name="divLoadingProgress" align="center" className="divWaiting" >
          <img alt="progress" src="../dist/img/loading.gif" />
        </div>
      )}
      
      <Helmet>
        <title>Announcement List</title>
      </Helmet>


      {/* Content Wrapper. Contains page content */}
      <div className="content-wrapper">
        {/* Content Header (Page header) */}
        <div className="content-header">
          <div className="row">
            <div className="col-md-10 offset-md-1">
              <div className="container-fluid">
                <h1 className="display-5">
                  {" "}
                  <i className="fas fa-bullhorn" /> Announcement{" "}
                </h1>
              </div>
            </div>
          </div>
        </div>
        {/* /.content-header */}
        {/* Main content */}
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-10 offset-md-1">
                <h5 className="display-5" >{" "}</h5>
                <div className="card  shadow">
                  <div className="card-header ">
                    <h3 className="card-title">
                      Result <small> ({isCount} items)</small>
                    </h3>
                    <div className="float-right">
                      <a
                        href="#!"
                        className="btn btn-primary btn-sm"
                        title="AddAnnouncement"
                        data-target="#modal-Add-Edit-Announcement"
                        data-toggle="modal"
                        onClick={() => Onclick_Add_Edit_Announcement("Add","-1","","","","","-1")}
                      >
                        <i className="fas fa-plus" /> Add Announce
                      </a>
                    </div>


                  </div>
                  {/* /.card-header */}
                  <div className="card-body table-responsive p-0">
                  <input type="hidden" id="hd_iddel"></input>
                  <TableContainer>
                  <Table
                     //<table
                      stickyHeader
                      aria-label="sticky table"
                      className="table table-head-fixed table-hover"
                      border={0}
                    >
                     
                    <TableHead>
                      <TableRow>
                        <TableCell width={"5%"}  align={"left"}><b>#</b></TableCell>
                        <TableCell width={"25%"} align={"left"}><b>Header</b></TableCell>
                        <TableCell width={"30%"} align={"left"}><b>Text</b></TableCell>
                        <TableCell width={"20%"} align={"left"}> <b>Date</b></TableCell>
                        <TableCell width={"10%"} align={"center"}> <b>Status</b></TableCell>
                        <TableCell width={"10%"} align={"left"}></TableCell>
                      </TableRow>
                    </TableHead>

                    <TableBody>
                    {(listAnnouncement.length === 0 && (
                      <TableRow key={1}>
                        <TableCell colSpan={6} align="center">
                          {ConfigETC.NoData}
                        </TableCell>
                      </TableRow>
                          )) ||
                          listAnnouncement
                          .slice(
                            page * rowsPerPage,
                            page * rowsPerPage + rowsPerPage
                          )
                          .map((row) => (
                      <TableRow key={row.rowindex}>
                        <TableCell><div>{row.rowindex}</div>
                        </TableCell>
                        <TableCell align="left">
                        <div>{row.announce_header}</div>
                        </TableCell>
                        <TableCell align="left">
                        <div>{row.announce_text}</div>
                        </TableCell>
                        <TableCell align="left">
                        <div>{row.start_end_announce}</div>
                        </TableCell>
                        <TableCell align="center">
                        <div>
                          <span
                            className={
                              row.announce_status === 1
                                ? ConfigETC.Status_active
                                : ConfigETC.Status_inactive
                            }
                          >
                            {row.announce_status === 1
                            ? ConfigETC.SwitchButton_active_text
                            : ConfigETC.SwitchButton_inactive_text
                            }
                          </span>
                        </div>
                        </TableCell>
                        <TableCell align="left">
                          <div className="btn-group btn-group-sm">
                                                  
                            <a
                              href="#!"
                              className="btn btn-primary btn-sm"
                              title="AddAnnouncement"
                              data-target="#modal-Add-Edit-Announcement"
                              data-toggle="modal"
                              onClick={() =>
                                Onclick_Add_Edit_Announcement("Edit",
                                  row.announce_id,
                                  row.announce_header,
                                  row.announce_text,
                                  row.announce_start_date,
                                  row.announce_end_date,
                                  row.announce_status
                                )
                              }
                            >
                              <i className="fas fa-pencil-alt" />
                            </a>
                          
                            <a
                              href="#!"
                              onClick={() =>
                                onclick_DelAnnouncement(row.announce_id)
                              }
                              className="btn btn-default btn-sm"
                            >
                              <i className="fas fa-trash" />
                            </a>
                          
                          </div>
                        
                        </TableCell>
                      </TableRow>
                    ))}
                    </TableBody>
                  </Table>
                </TableContainer> 

                      {listAnnouncement.length > 0 && (
                        <TablePagination
                          rowsPerPageOptions={[ConfigETC.rowsPerPage]}
                          component="div"
                          count={listAnnouncement.length}
                          rowsPerPage={rowsPerPage}
                          page={page}
                          onPageChange={handleChangePage}
                          onRowsPerPageChange={handleChangeRowsPerPage}
                          ActionsComponent={PaginationActions}
                        />
                      )}

                    </div>
                    {/* /.card-body */}
                  </div>
                  {/* /.card */}
                </div>
              </div>
              {/* /.row (main row) */}
              
            </div>
            {/* /.container-fluid */}
            </section>
            {/* /.content */}
          </div>
          {/* /.content-wrapper */}

      
      {/*/////////////////////////////////////////////////////////// POPUP ADD OR EDIT Announcement ///////////////////////////////////////////////////////////////////////////*/ }
      {/* {isAddorEditTask && ( */}
              <>
<div className="modal fade" id="modal-Add-Edit-Announcement">
  <div className="modal-dialog modal-lg">
    <div className="modal-content">
      <div className="modal-header">
        <h4 className="modal-title"><i className="fa fa-bullhorn" /> Announcement <small>({pgAct})</small></h4> 
        <button type="button" 
                className="close"
                id="close_Announce_Add_Edit"
                data-dismiss="modal" 
                aria-label="Close">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div className="modal-body">
      <input type="hidden" id="hd_announce_id"></input>
        <div className="form-group ">
          <label className="text-sm col-form-label text-right">Header <span className="text-danger">*</span> </label>
          <div>
            <input type="text" 
            className="form-control form-control-sm" 
            placeholder="Header" 
            id="txt_announce_header" />
          </div>
        </div>
        <div className="form-group ">
          <label className="text-sm col-form-label text-right">Announcement Text<span className="text-danger">*</span> </label>
          <div>
            <textarea 
            className="form-control" rows={3} 
            placeholder="Announcement Text ..." 
            id="txt_announce_text" />
          </div>
        </div>
        <div className="form-group row">
          <label className="text-sm col-sm-2 col-form-label text-right">Date Start<span className="text-danger">*</span></label>
          <div className="col-sm-4">
            <DatePickerComponent
                id="txt_announce_start_date"
                placeholder="Start Date"
                format="dd/MM/yyyy"
                strictMode={true}
            />

          </div>
          <label className="text-sm col-sm-2 col-form-label text-right">Date End<span className="text-danger">*</span></label>
          <div className="col-sm-4">
            <DatePickerComponent
                id="txt_announce_end_date"
                placeholder="End Date"
                format="dd/MM/yyyy"
                strictMode={true}
            />

          </div>
        </div>
        <div className="form-group row">
          <label className="text-sm col-sm-2 col-form-label text-right">Status </label>
          <div className="col-sm-4">
            <BootstrapSwitchButton
              onChange={(checked) => { setIsAnnounceStatus(checked) }}
              checked={isAnnounceStatus}
              width={ConfigETC.SwitchButton_in_active_width} 
              onlabel={ConfigETC.SwitchButton_active_text}
              onstyle={ConfigETC.SwitchButton_active_color}
              offlabel={ConfigETC.SwitchButton_inactive_text}
              offstyle={ConfigETC.SwitchButton_inactive_color}
              size="xs"
          />
          </div>
        </div>
      </div>   
      <div className="modal-footer">
      
        <span className="text-right">
          <button 
          type="button" 
          className="btn btn-primary" 
          onClick={Onclick_SaveAnnouncement}
          >
            <i className="fa  fa-save" />  Save
          </button>
        </span>
        
      </div>
    </div>
    {/* /.modal-content */}
  </div>
  {/* /.modal-dialog */}
</div>
</> 
{/* )}  */}
   {/*/////////////////////////////////////////////////////////// POPUP ADD OR EDIT Announcement ///////////////////////////////////////////////////////////////////////////*/ }


    </>
  );
}

export default M_announcement;
